export const defaultTimer = 60;
